import { featureCollection, point } from '@turf/helpers'

import PoziAPIData from 'api/data'

/**
 * Pozi API Adapter
 */
function PoziAPIGSheet () {
  // Adapters
  const adapters = {
    getDataAsGeoJSON: function (url, key, query) {
      return getDataAsGeoJSON(url, key, query)
    }
  }

  /**
   * Handle data requests
   */
  var getDataAsGeoJSON = function (url, key, query) {
    return new Promise(function (resolve, reject) {
      if (!url) {
        url = 'https://spreadsheets.google.com/tq'
      }

      if (key && key !== '') {
        url += '?key=' + key
      }

      if (query && query !== '') {
        url += '&tq=' + query
      }

      url += '&alt=json'

      console.log('getDataAsGeoJSON: ', url)

      PoziAPIData().ajax({
        cache: false,
        dataType: 'text',
        url,
        error: function (err) {
          console.log('getDataAsGeoJSON ajax error: ', err)
          reject(err)
        },
        success: function (gSheetData) {
          handleGSheetFormat(gSheetData)
            .then(function (geojson) {
              resolve(geojson)
            })
            .catch(function (err) {
              console.log('handleGSheetFormat error: ', err)
              reject(err)
            })
        }
      })
    })
  }

  /**
   * Handle data requests
   * @param gSheetData (string directly from google spreadsheets)
   * @return FeatureCollection
   */
  var handleGSheetFormat = function (gSheetData) {
    return new Promise(function (resolve, reject) {
      let gsheetObj
      const features = []
      let fc = featureCollection(features)

      // Strip non-json text from gSheetFormat
      let jsonStr = gSheetData
      // jsonStr = jsonStr.replace(/\r?\n|\r/g, " ")
      jsonStr = jsonStr.replace('/*O_o*/', '')
      jsonStr = jsonStr.replace('google.visualization.Query.setResponse(', '') // For normal return
      jsonStr = jsonStr.replace('google.visualization.Query.setResponse(', '') // For error return
      jsonStr = jsonStr.slice(0, -2)

      try {
        gsheetObj = JSON.parse(jsonStr)
      } catch (err) {
        const err1 = 'handleGSheetFormat: Unable to parse json.'
        return reject(err1)
      }

      // console.log("gsheetObj: ", gsheetObj)

      if (!gsheetObj || !gsheetObj.table || !gsheetObj.table.cols || !gsheetObj.table.rows) {
        console.log('gsheetObj: ', gsheetObj)
        if (gsheetObj.errors) {
          console.log('gsheetObj.errors: ', gsheetObj.errors)
        }
        const err2 = 'Invalid gSheetData'
        return reject(err2)
      }

      if (gsheetObj.table.rows.length === 0) {
        return resolve(fc)
      }

      // Find Lng/Lat location
      let lngKey = ''
      let latKey = ''
      let lngValue = 0
      let latValue = 0
      let colname = ''
      let colvalue = ''

      for (const colkey in gsheetObj.table.cols) {
        if (gsheetObj.table.cols[colkey].label) {
          colname = gsheetObj.table.cols[colkey].label.toLowerCase()
          if (colname === 'lng' || colname === 'lon' || colname === 'long' || colname === 'longitude' || colname === 'x') {
            lngKey = colkey
          } else if (colname === 'lat' || colname === 'latitude' || colname === 'y') {
            latKey = colkey
          }
        }
      }

      if (lngKey === '' || latKey === '') {
        console.log('Unable to find lng or lat key in spreadsheet... must be in this format: lng,lon,long,longitude,lat,latitude... continuing...')
        // return resolve(fc)
      }

      for (const rowkey in gsheetObj.table.rows) {
        const rowarray = gsheetObj.table.rows[rowkey].c

        // Build the properties object
        const properties = {}
        let propertiesSetForRow = false
        for (const rowcolkey in rowarray) {
          const row = rowarray[rowcolkey]
          if (row) {
            colname = gsheetObj.table.cols[rowcolkey].label || ''
            colvalue = row.v || ''
            if (colname !== '') {
              properties[colname] = colvalue
              propertiesSetForRow = true
            }
          }
        }

        lngValue = 0
        latValue = 0

        if (lngKey !== '' && latKey !== '') {
          if (rowarray && rowarray[lngKey] && rowarray[latKey] && rowarray[lngKey].v && rowarray[latKey].v) {
            lngValue = rowarray[lngKey].v
            latValue = rowarray[latKey].v
          }
        }

        if (propertiesSetForRow) {
          const pt = point([lngValue, latValue], properties)
          features.push(pt)
        }
      }

      fc = featureCollection(features)

      resolve(fc)
    })
  }

  // Return adapters (must be at end of adapter)
  return adapters
}

export default PoziAPIGSheet
// End A (Adapter)
